// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"96b2a10d","129":"7cfb9344","197":"95b4837f","618":"d7baf451","992":"f1b67c68"}[chunkId] + ".chunk.js";
};